var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#B5B5B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.7637C8 13.6497 8.02734 13.4697 8.08203 13.2236C8.11393 13.0824 8.16178 12.8955 8.22559 12.6631L9.06641 9.51855C9.07552 9.4821 9.08236 9.44564 9.08691 9.40918C9.09603 9.37272 9.10059 9.33854 9.10059 9.30664C9.10059 9.11979 9.04134 9.00358 8.92285 8.95801C8.80436 8.91243 8.58789 8.88281 8.27344 8.86914V8.5C8.53776 8.48177 8.92057 8.44531 9.42188 8.39062C9.92773 8.33138 10.2855 8.28125 10.4951 8.24023L11.0967 8.12402L10.0098 12.1094C9.91862 12.4512 9.8571 12.6882 9.8252 12.8203C9.74316 13.1576 9.70215 13.3763 9.70215 13.4766C9.70215 13.5768 9.72493 13.6429 9.77051 13.6748C9.81608 13.7021 9.86621 13.7158 9.9209 13.7158C10.0622 13.7158 10.2376 13.5951 10.4473 13.3535C10.6569 13.112 10.8415 12.859 11.001 12.5947L11.3086 12.793C10.8529 13.4629 10.5042 13.9141 10.2627 14.1465C9.86621 14.5293 9.44238 14.7207 8.99121 14.7207C8.736 14.7207 8.50586 14.6432 8.30078 14.4883C8.10026 14.3288 8 14.0872 8 13.7637ZM10.707 5C10.9668 5 11.1878 5.09115 11.3701 5.27344C11.5524 5.45573 11.6436 5.67676 11.6436 5.93652C11.6436 6.19629 11.5524 6.4196 11.3701 6.60645C11.1878 6.78874 10.9668 6.87988 10.707 6.87988C10.4473 6.87988 10.224 6.78874 10.0371 6.60645C9.85482 6.4196 9.76367 6.19629 9.76367 5.93652C9.76367 5.67676 9.85482 5.45573 10.0371 5.27344C10.224 5.09115 10.4473 5 10.707 5Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.22511bb054004924ee9ab76003f7341e.svg";
export { ForwardRef as ReactComponent };